module.exports = "<p class=\"topBack\" ng-if=\"!$ctrl.disableBack\">\n  <a ng-click=\"$ctrl.goToCatalog()\" class=\"button back\" ga-track-event=\"['Manage Purchase', 'Click', 'Back']\">{{ 'common.return' | translate }}</a>\n</p>\n<h2>{{ 'managePurchase.myPurchase' | translate }}</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manage-purchase/common/manage-purchase-topblock/manage-purchase-topblock.html
// module id = 910
// module chunks = 0